module.exports = window["peachpay_checkout_blocks"];